import { computed } from '@vue/composition-api'

export function useMessenger<T>(getter: () => T, setter: (value: T) => any) {
  return computed({
    get() {
      return getter()
    },
    set(value: T) {
      return setter(value)
    },
  })
}
